/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_P1dInputs */

const en_mk_sol_konsultan_p1d = /** @type {(inputs: Mk_Sol_Konsultan_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarising documents, hunting precedents, building an outline — necessary, hard to sell as consultant hours.`)
};

const id_mk_sol_konsultan_p1d = /** @type {(inputs: Mk_Sol_Konsultan_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merangkum dokumen, mencari preseden, menyusun kerangka — perlu dilakukan, sulit dijual sebagai jam konsultan.`)
};

/**
* | output |
* | --- |
* | "Summarising documents, hunting precedents, building an outline — necessary, hard to sell as consultant hours." |
*
* @param {Mk_Sol_Konsultan_P1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_p1d = /** @type {((inputs?: Mk_Sol_Konsultan_P1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_P1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_p1d(inputs)
	return en_mk_sol_konsultan_p1d(inputs)
});